import { useCoinSubscriptionQuery } from '@repo/cf-user/hooks/use-user-data'
import { usePricesForUser } from '@repo/cf-user/hooks/use-prices'
import type { CoinSubscriptionPlan } from 'payments/payments-dialog/lib/plans'
import { SUBSCRIPTION_TIERS, COIN_PLAN_TO_SUBSCRIPTION_PLAN } from '../constants/coin-top-up'

const RELEASED_COIN_SUBSCRIPTION_PLAN: CoinSubscriptionPlan = 'coinPack700k'

export function useCoinSubscriptionTier() {
  const tier =
    SUBSCRIPTION_TIERS.find(t => t.plan === RELEASED_COIN_SUBSCRIPTION_PLAN) ??
    SUBSCRIPTION_TIERS.find(t => t.plan === 'coinPack1M')!
  const subscriptionPlan = COIN_PLAN_TO_SUBSCRIPTION_PLAN[tier.plan]

  const coinSubQuery = useCoinSubscriptionQuery()
  const hasTargetPlan = coinSubQuery.data?.plan === subscriptionPlan
  const hasCoinSubscription = coinSubQuery.data?.isSubscribed === true

  const { pricesIncludeVat } = usePricesForUser()
  const priceCents = pricesIncludeVat ? tier.priceUsdVatNL : tier.priceUsd

  return {
    tier,
    subscriptionPlan,
    hasTargetPlan,
    hasCoinSubscription,
    priceCents,
    isCoinSubscriptionPending: coinSubQuery.isPending,
  }
}

export function useCoinSubscriptionTiers() {
  const { pricesIncludeVat } = usePricesForUser()

  return SUBSCRIPTION_TIERS.map(tier => ({
    plan: tier.plan,
    coins: tier.coins,
    priceCents: pricesIncludeVat ? tier.priceUsdVatNL : tier.priceUsd,
  }))
}
